<template>
    <modal
        v-if="isActive"
        :show="showModal"
        :showContent="showContent"
        :pageTitle="title"
        :acl="acl"
        :url="url"
        @close="onCloseModal"
        :closeBtn="closeBtn"
        position="right"
        size='small'
        id="annotations-root"
        class="annotations-panel">
        <template v-slot:content>
            <div class="row">
                <div class="col">
                    <div class="title"> {{ title }}</div>
                    <hr/>
                </div>
            </div>
            <annotation-grid
                key="features"
                ref="AnnotationsGrid"
                :moduleCode="moduleCode"
                :map="getMap()"
                :url="url"
                :reset="!showModal"
                :txtConfirmLeaveSession="txtConfirmLeaveSession"
                :readonlyFormItem="readonlyFormItem"
                :showHideCollection="true"
                :zoomToCollection="true"
            />
        </template>
    </modal>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import AnnotationMixin from '../shared/annotation/AnnotationMixin';
    import AnnotationGrid from '../shared/annotation/components/AnnotationRecordGrid';

    let modes = {
        LIST: 'list',
        RECORD: 'record',
    };

    export default {
        mixins: [
            GlobalMixin,
            ButtonControlMixin,
            AnnotationMixin,
        ],
        components: {
            Modal: () => import(/* webpackChunkName: "modal-data" */ '@/app/shared/components/modals/ModalData'),
            AnnotationGrid,
        },
        props: {
            closeBtn: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                idPanel: 'annotations',
                className: 'ol-annotations',
                txtConfirmLeaveSession: 'Deseja abandonar a sessão de edição da anotação?',
                showContent: false,
                lists: {
                    loaded: false,
                },
                mode: modes.LIST,
                // annotationsObject: {
                //     "features":[
                //       {
                //          "type":"FeatureCollection",
                //          "properties":{
                //             "id":"e9005b80-79e1-11ec-b43f-79eda3ac9411",
                //             "title":"assas",
                //             "visibility":true,
                //             "description":"asass\nasassasasaa\nasas"
                //          },
                //          "features":[
                //             {
                //                "type":"Feature",
                //                "geometry":{
                //                   "coordinates":[
                //                      -102051,
                //                      -104246
                //                   ],
                //                   "type":"Point"
                //                },
                //                "properties":{
                //                   "id":"ec552bd0-79e1-11ec-b43f-79eda3ac9411",
                //                   "isValidFeature":true,
                //                   "canEdit":false,
                //                   "geometryTitle":"xxxx"
                //                },
                //                "style": {"highlight":false}
                //             },
                //             {
                //                "type":"Feature",
                //                "geometry":{
                //                   "type":"LineString",
                //                   "coordinates":[
                //                      [
                //                         -102286,
                //                         -105700
                //                      ],
                //                      [
                //                         -101286,
                //                         -104898
                //                      ],
                //                      [
                //                         -98748,
                //                         -105160
                //                      ],
                //                      [
                //                         -100732,
                //                         -106841
                //                      ]
                //                   ]
                //                },
                //                "properties":{
                //                   "id":"071f3be0-79e2-11ec-b43f-79eda3ac9411",
                //                   "isValidFeature":true,
                //                   "canEdit":false,
                //                   "selected":true,
                //                   "geometryTitle":"ttttt"
                //                },
                //             },
                //             {
                //                 "type":"Feature",
                //                 "geometry":{
                //                     "type":"Point",
                //                     "coordinates":[
                //                         -102283.7552738966,
                //                         -103341.4452738978
                //                     ]
                //                 },
                //                 "properties":{
                //                     "id":"9ff3f930-a5db-11ec-84cc-951706cc5f0e",
                //                     "isValidFeature":true,
                //                     "canEdit":false,
                //                     "selected":false,
                //                     "geometryTitle":"Círculo",
                //                     "isCircle":true,
                //                     "center":[
                //                         -102283.7552738966,
                //                         -103341.4452738978
                //                     ],
                //                     "radius":496.74892839400854,
                //                     "_geom":"circle"
                //                 },
                //                 "style":{

                //                 }
                //             }
                //          ],
                //          "style":{
                //             "highlight":false
                //          }
                //       },
                //       {
                //          "type":"FeatureCollection",
                //          "properties":{
                //             "id":"3f86a040-79e2-11ec-b43f-79eda3ac9411",
                //             "title":"tytyt",
                //             "visibility":false
                //          },
                //          "features":[
                //             {
                //                "type":"Feature",
                //                "geometry":{
                //                   "coordinates":[
                //                      -101884,
                //                      -101887
                //                   ],
                //                   "type":"Point"
                //                },
                //                "properties":{
                //                   "id":"43a7e850-79e2-11ec-b43f-79eda3ac9411",
                //                   "isValidFeature":true,
                //                   "canEdit":false
                //                },
                //                "style":[
                //                   {
                //                      "iconGlyph":"comment",
                //                      "iconShape":"square",
                //                      "iconColor":"blue",
                //                      "highlight":false,
                //                      "id":"43a77320-79e2-11ec-b43f-79eda3ac9411"
                //                   }
                //                ]
                //             }
                //          ],
                //          "style":{
                //             "highlight":false
                //          }
                //       }
                //     ],
                //     "type":"cityhub-annotations"
                //     // 'type': 'FeatureCollection',
                //     // 'crs': {
                //     //     'type': 'name',
                //     //     'properties': {
                //     //         'name': 'EPSG:3857',
                //     //     },
                //     // },
                // },
            }
        },
        computed: {
            showModal() {
                return this.isActive && this.isPanelVisible;
            },
            readonlyFormItem() {
                return false;
            },
        },
        methods: {
            initialize: function() {
                if(this.showContent){
                    return;
                }
                this.showContent=true;
                this.$nextTick(() => {
                    this.activeTooltip();
                });
            },
            addButtonMap: function(_map){
                let btn = _map.createBtnImg(
                    this.assetsPathTheme('/map/annotations.svg'),
                    _map.getControlClassName(this.orderClassName),
                    this.title,
                    [
                        {
                            type: 'click',
                            event: (evt) =>
                            {
                                this.openPanel();
                                evt.stopPropagation();
                            }
                        }
                    ],
                    this.lblBtn
                );
                _map.addControl(this.posBtnMap, btn);
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                    let el = $(btn.element); if(el) el.hide()
                });
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                    let el = $(btn.element); if(el) el.show()
                });
                return btn;
            },
            onCloseModal: function() {
                let grid = this.$refs['AnnotationsGrid'];
                if(grid) {
                    grid.checkRecordSession()
                    .then(res => {
                        if(res) {
                            this.closePanel();
                        }
                    });
                }else{
                    this.closePanel();
                }
            },
        },
        watch: {
            showModal: {
                immediate: false,
                handler(value, oldVal) {
                    if(value){
                        this.initialize();
                    }
                },
            },
        },
    }
</script>